import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    padding: '0.625rem 0.875rem',
    borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease'
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.625rem'
  },
  message: {
    fontWeight: 500,
    fontSize: '0.8125rem',
    lineHeight: '1.4',
    flex: 1
  },
  progress: {
    marginTop: '0.5rem',
    height: '4px',
    borderRadius: '2px',
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'currentColor'
    }
  }
});

export default useStyles;
